import { reserveLabel, safeHttpUrl } from '@shared/booking';
import type { ServiceKind } from '@shared/types';

export function BookingLink({
  href,
  kind,
  label,
  className = '',
}: {
  href: string | null | undefined;
  kind?: ServiceKind | string;
  label?: string;
  className?: string;
}) {
  const url = safeHttpUrl(href);
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`mt-3 inline-flex w-full items-center justify-center rounded-card bg-navy px-4 py-2.5 text-sm font-semibold text-sand ${className}`}
    >
      {label ?? reserveLabel(kind)}
    </a>
  );
}
